import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { BLUE, WHITE } from '../../Styles';
import { StyledButton } from '../Styles';

export const WatchModeButton = observer(() => {
  const {
    UIStore: { handleMonitorChatOnly },
  } = useStores();

  return (
    <StyledButton
      bgColor={BLUE}
      color={WHITE}
      onClick={() => handleMonitorChatOnly(true)}
      style={{ cursor: 'pointer' }}
    >
      Access Remote Debugging
    </StyledButton>
  );
});

export default WatchModeButton;
